import React, { useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Center,
  FormControl,
  FormLabel,
  Input,
  Select,
  FormErrorMessage,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import * as yup from "yup";

import Typography from "../../../components/Common/Typography";
import { callApiWithToken } from "../../../utils/http_common";
const EditModal = ({ isOpen, onClose, data, refreshData, roles, showToast }) => {
  const { email = "", appRole = [] } = data;

  const [loading, setLoading] = useState(false);
  const validationSchema = yup.object({
    role: yup.string("Select role").required("Role is required"),
  });
  const formik = useFormik({
    initialValues: {
      role: appRole[0],
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const role = values.role.toLowerCase().replace(/ /g, "_");
        const payload = { email, role };
        const { data } = (await callApiWithToken.post("/customer/team/update", payload)) || {};
        if (data?.data?.status) {
          showToast({ title: "Teammate details updated successfully", status: "success" });
          refreshData();
        }
      } catch (e) {
        showToast({ title: e.response?.data?.error?.message || "Something went wrong", status: "error" });
      } finally {
        setLoading(false);
        formik.resetForm();
        onClose();
      }
    },
  });

  const onModalClose = () => {
    formik.resetForm();
    setLoading(false);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onModalClose}>
      <ModalOverlay />
      <ModalContent>
        <Center mt={4}>
          <Typography color="primary" colorweight="500" weight="bold">
            Edit Teammate Details
          </Typography>
        </Center>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired mt={5}>
            <FormLabel>Email</FormLabel>
            <Input placeholder="E.g. name@email.com" id="email" name="email" value={email} isDisabled />
          </FormControl>
          <FormControl isRequired mt={5} isInvalid={formik?.touched?.role && formik?.errors?.role}>
            <FormLabel>Role</FormLabel>
            <Select placeholder="Select role" id="role" name="role" onChange={formik.handleChange} value={formik.values.role}>
              {roles?.map((option, i) => (
                <option key={i} value={option}>
                  {option}
                </option>
              ))}
            </Select>
            <FormErrorMessage>{formik?.errors?.role}</FormErrorMessage>
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            bg={"#F2F2F2"}
            _hover={{ bg: "#F2F2F2" }}
            color="#808080"
            width={"113px"}
            height={"40px"}
            rounded={"6px"}
            fontSize={"14px"}
            fontWeight={"400"}
            fontFamily={"DM Sans"}
            mr={3}
            onClick={onModalClose}
          >
            Cancel
          </Button>
          <Button
            bg={"#1A4FD6"}
            _hover={{ bg: "#366cf5" }}
            color="white"
            width={"113px"}
            height={"40px"}
            rounded={"6px"}
            fontSize={"14px"}
            fontWeight={"400"}
            fontFamily={"DM Sans"}
            onClick={formik.handleSubmit}
            isLoading={loading}
          >
            Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditModal;
